import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { listTimeOffRequests } from '../application/list-time-off-requests'
import { ownTimeOffRequests$, timeOffListVersion$ } from '../store'
import { timeoff, notify } from '../wiring'

const useOwnTimeOffRequests = (memberId: string | null) => {
	const requests = useSelector(ownTimeOffRequests$)
	const version = useSelector(timeOffListVersion$)

	const reload = useCallback(async () => {
		const result = await listTimeOffRequests(
			timeoff,
			{ q: null, memberId, memberIds: null, approvalStage: null, type: null, start: null, end: null },
			notify,
		)
		ownTimeOffRequests$.set(result)
	}, [memberId])

	useEffect(() => {
		reload()
	}, [reload, version])

	return { requests }
}

export { useOwnTimeOffRequests }
